module.exports = __webpack_public_path__ + "static/logo-white-c837c7e07a372d2fbf668a22a6a6b84b.png";